import { AxiosError } from 'axios';

export interface IApiErrorResponse {
  code: string;
  message: string;
}

export const errorHandler = (err: any) => {
  const error = err as AxiosError<IApiErrorResponse>;
  if (error.response && error.response.data) {
    return handleErrorResponse(error.response.data);
  } else {
    console.error(error);
  }
};

const handleErrorResponse = (apiErrorResponse: IApiErrorResponse) => {
  const { code, message } = apiErrorResponse;

  switch (code) {
    case 'error.captcha.expired':
    case 'error.captcha.mismatch':
    case 'error.unknown':
    default:
      if (process.env.NODE_ENV === 'development') {
        console.error(code, ':', message);
        return message;
      } else {
        console.error(message);
        return message;
      }
  }
};
